import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import ReactiveButton from 'bricks/ReactiveButton';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * if isInBasket is passed, we show green button
 */
export default function BuyButtonLayout({
  abTestValue,
  className,
  href,
  isInBasket,
  isLarge,
  isSeoButton,
  isWide,
  label,
  onClick,
}) {
  return (
    <div className={cx('wrapper', { large: isLarge }, className)}>
      <ReactiveButton
        className={cx('button')}
        href={href}
        isActive={isInBasket}
        isLarge={isLarge}
        isWide={isWide}
        onClick={onClick}
      >
        {' '}
        {abTestValue === 'true' && isSeoButton ?
          <a className={cx('seoHide')} href="">
            <span>
              <i>Купить</i>
            </span>
          </a>
        : null}
        {label || (isInBasket && 'В корзине') || 'Купить'}
      </ReactiveButton>
    </div>
  );
}

BuyButtonLayout.propTypes = {
  abTestValue: PropTypes.bool,
  className: PropTypes.string,
  href: PropTypes.string,
  isInBasket: PropTypes.bool,
  isLarge: PropTypes.bool,
  isSeoButton: PropTypes.bool,
  isWide: PropTypes.bool,
  label: PropTypes.string,
  onClick: PropTypes.func,
};

BuyButtonLayout.defaultProps = {};
